module.exports = "/_next/static/images/Hero@2x-c2329157d9695d50ba9ae0b25f9dfdfc.png";